import styled from 'styled-components/macro'

export const StyledModalStep = styled.div`
  #modal-footer {
    #primary-btn {
      margin-left: 2em;
    }
  }
`
